require('./build/scripts/ng-map.js');
module.exports = 'ngMap';


//////////////////
// WEBPACK FOOTER
// ./~/ngmap/index.js
// module id = 1023
// module chunks = 1